import { JSX } from "react";
import styles from "rivals/components/shared/Gallery/GalleryModal/GalleryModal.module.scss";
import { Props } from "rivals/components/shared/Gallery/GalleryModal/GalleryModalFooter/types";
import GalleryToggle from "rivals/components/shared/Gallery/GalleryModal/GalleryToggle";

export default function GalleryModalFooter({
  shareMenu,
  showSlideshow,
  showPaywall,
  onViewChange
}: Props): JSX.Element {
  return (
    <div className={styles.footer}>
      {showPaywall && <div className={styles.overlay} />}
      <GalleryToggle
        onViewChange={onViewChange}
        showSlideshow={showSlideshow}
      />
      {shareMenu}
    </div>
  );
}
